export const datacheck = [
  {
    id: 1,
    text: "Mediante el mensaje enviado manifiesto mi conformidad del reclamo o queja ingresado.",
    textWarning: "Pendiente dar conformidad del reclamo o queja ingresado.",
  },
  {
    id: 2,
    text: "He leído y acepto la ",
    textWarning:
      "Pendiente aceptar la “Política de privacidad”.",
    textUrl: "Política de privacidad.",
    directUrl:
      "/transparencia",
  },
];

export const datacheckRequerimiento = [
  {
    id: 1,
    text: "Mediante el mensaje enviado manifiesto mi conformidad del requerimiento ingresado.",
    textWarning: "Pendiente dar conformidad del requerimiento ingresado.",
  },
  {
    id: 2,
    text: "He leído y acepto la ",
    textWarning:
      "Pendiente aceptar la “Política de privacidad”.",
    textUrl: "Política de privacidad.",
    directUrl:
      "/transparencia",
  },
];


export const  typeComplaints = [
  { id: 2, name: "Tengo un requerimiento" },
  { id: 1, name: "Tengo un reclamo o queja" },
 
];

export const titleRadioClaim ="¿Cómo deseas recibir la respuesta a tu reclamo o queja?";
export const titleRadioSurgirClient ="¿Ya eres cliente de Fondos Colectivos?";
export const titleRadioRequirements ="¿Cómo deseas recibir la respuesta a tu requerimiento?";
export const titleRadioAdress ="¿Tu dirección de contacto es de Perú?";
export const subTitleClaim ="Compártenos tu reclamo o queja";
export const subTitleRequirements ="Compártenos tu requerimiento";
export const subTitleDataStepTwo ="Bríndanos tus datos personales";
export const optionalInputMessage ="Solo en caso de Persona Jurídica";
export const descripTooltipClaim = "Puede ser un voucher de pago o documentación que consideres que tenga relación con tu reclamo o queja."
export const descripTooltipRequirement = "Puede ser un voucher de pago o documentación que consideres que tenga relación con tu requerimiento."
export const GotoFrequentQuestionsText1 ="";
export const GotoFrequentQuestionsText2 ="";
export const GotoFrequentQuestionsTitle1 ="¿Qúe es un reclamo?";
export const GotoFrequentQuestionsTitle2 ="¿Qué es un requerimiento?";
export const GotoFrequentQuestionsSubTitle1 ="Es una comunicación presentada por el usuario o tercero a nombre del usuario, expresando su insatisfacción con la operación, servicio y/o producto recibido o por incumplimiento de las obligaciones contempladas en los contratos o norma vigente, o manifestando la presunta afectación de su legítimo interés.";
export const GotoFrequentQuestionsSubTitle2 ="Es una comunicación presentada por un usuario o tercero a nombre del usuario, mediante la cual se busca una acción por parte de la empresa. Los requerimientos comprenden la atención de consultas, solicitudes y otras solicitudes.";
export const ContactData ="Bríndanos tus datos de contacto";

